<template>
  <div class="warp">
    <BaseHeader />
    <main>
      <PaymentSuccessLeft page="paymentSuccess" />

      <div id="payment">
        <a
          class="btn titillium-sm"
          @click="close_window"
          style="padding-right: 46px;"
          >{{ text.closed }}
        </a>
      </div>
    </main>
  </div>
</template>

<script>
import PaymentSuccessLeft from '../components/PaymentSuccessLeft.vue'

export default {
  data() {
    return {
      refreshTimer: null
    }
  },
  created() {
    this.refreshTimer = setTimeout(() => {
      if (this.$route.name == 'paymentSuccess') {
        this.$router.replace(
          `/paymentMethods/?linkcode=${this.$route.query.linkcode}`
        )
      }
    }, 3000)
  },
  beforeDestroy() {
    if (this.refreshTimer) {
      clearTimeout(this.refreshTimer)
      this.refreshTimer = null
    }
  },
  methods: {
    close_window() {
      window.close(``, `_parent`, ``)
    },
    toDigit(num) {
      return this.twoDecimal(num)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    twoDecimal(val) {
      return parseFloat(val).toFixed(2)
    },
    checkRedirectUrl() {
      let res = false
      if (
        this.$store.state.backUrl != null &&
        this.$store.state.backUrl != ''
      ) {
        res = true
      } else {
        res = false
      }
      return res
    }
  },
  computed: {
    text() {
      let obj = {}
      if (this.$store.state.language == 'TH') {
        obj = {
          closed: 'ปิด'
        }
      } else {
        obj = {
          closed: 'Close'
        }
      }
      return obj
    },
    custname() {
      return this.$store.state.name
    },
    total() {
      return this.twoDecimal(this.$store.state.total)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    paid() {
      return this.$store.state.paid
    },
    outstanding() {
      return this.$store.state.outstanding
    },
    ref1() {
      return this.$store.state.ref1
    },
    billPayment() {
      return this.$store.state.billPayment ? this.$store.state.billPayment : []
    }
  },
  components: { PaymentSuccessLeft }
}
</script>
